import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import constants from '../../api/api_urls';
import { apiGet } from '../../api/api_methods';
import { ADMIN_ENDPOINTS } from '../../api/api_endpoints';

// Action
export const fetchDashboard = createAsyncThunk('fetchDashboard', async (clusterId = null) => {
  let url = ADMIN_ENDPOINTS.ANALYTICS_DASHBOARD_DETAILS;

  if (clusterId) {
    url += `?cluster=${clusterId}`;
  }

  const response = await apiGet(url);

  return response.body;
});

const dashBoardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDashboard.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDashboard.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchDashboard.rejected, (state, action) => {
      console.log('Error', action.payload);
      state.isError = true;
    });
  },
});

export default dashBoardSlice.reducer;
